<template>
    <div class="flex flex-column gap-10">
        <template v-if="history.created && history.creator">
            <strong>Erstellung</strong>

            <div class="flex flex-vertical-middle flex-space-between gap-15 margin-bottom-15">
                <div class="flex flex-vertical-middle gap-5 margin-left-20">
                    <person-box-user :id="history.creator">
                        <template #name="{username}">
                            <span>{{username}}</span>
                        </template>

                        <template #default>{{dateHelper('d.m.Y, H:i', history.created)}} Uhr</template>
                    </person-box-user>
                </div>

                <span>Eintrag erstellt</span>
            </div>
        </template>

        <strong>Bearbeitungen</strong>

        <loading-indicator v-if="!editHistory"/>
        <template v-else-if="!editHistoryEntries.length">Kein Verlauf für diesen Eintrag vorhanden.</template>
        <list-pager v-else :entries="editHistoryEntries" #default="{listEntries}" current-scope="entry-history-popup"
            :available-page-sizes="[10, 25, 50]" :default-entries-per-page="10" :show-entry-count="editHistoryEntries.length >= 10">
            <div v-for="editEntry in listEntries" class="flex flex-vertical-middle flex-space-between gap-15 spacer-5">
                <div class="flex flex-vertical-middle gap-5">
                    #{{editEntry.index}}

                    <person-box-user :id="editEntry.editor">
                        <template #name="{username}">
                            <span>{{username}}</span>
                        </template>

                        <template #default>{{dateHelper('d.m.Y, H:i', editEntry.edited)}} Uhr</template>
                    </person-box-user>
                </div>

                <span>Eintrag bearbeitet</span>
            </div>
        </list-pager>
    </div>
</template>

<script lang="ts">
    import ListPager from '@/components/ListPager.vue';
    import LoadingIndicator from '@/components/LoadingIndicator.vue';
    import {errorHandler} from '@/utils/portuna';
    import {Component, Prop, Vue} from 'vue-facing-decorator';
    import dateHelper from '../utils/portuna/dateHelper';
    import PersonBoxUser from './PersonBoxUser.vue';

    @Component({
        name: 'EntryHistoryEditHistoryPopup',
        components: {
            ListPager,
            LoadingIndicator,
            PersonBoxUser,
        },
        methods: {dateHelper},
    })
    export default class EntryHistoryEditHistoryPopup extends Vue
    {
        @Prop({
            type: Object,
            required: true,
        }) history: IEntryHistory;

        @Prop({
            type: String,
            default: '',
        }) module: string;

        @Prop({
            type: String,
            default: '',
        }) namespace: string;

        @Prop({
            type: Number,
            default: 0,
        }) entryId: number;

        @Prop({
            type: Array,
            default: null,
        }) entries: Nullable<ILogEditHistoryEntry[]>;

        editHistory: Nullable<ILogEditHistoryEntry[]> = null;

        get editHistoryEntries()
        {
            let entries = this.editHistory;

            if (!this.editHistory.length && (this.history.editor || this.history.edited))
            {
                entries = [
                    {
                        editor: this.history.editor,
                        edited: this.history.edited,
                    },
                ];
            }

            return entries?.map((entry, index) => Object.assign({index: entries.length - index}, entry));
        }

        created(): void
        {
            if (this.entries)
            {
                this.editHistory = this.entries;
            }
            else
            {
                this.fetch();
            }
        }

        fetch(): void
        {
            this.axios.get('/log/fetch-entry-history/module/' + this.module + '/namespace/' + this.namespace + '/entry-id/' + this.entryId)
            .then(({data: {data}}) =>
            {
                this.editHistory = data.edit_history || [];
            })
            .catch(errorHandler);
        }
    };
</script>
